import { render } from "./come-froms.vue?vue&type=template&id=74ab8506"
import script from "./come-froms.vue?vue&type=script&lang=js"
export * from "./come-froms.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__